/**
 * Amazon-style add for the quote (logo-template) product form.
 *
 * Why this exists instead of the theme's stock AjaxProduct handler:
 * that handler POSTs `form.serialize()`, which silently DROPS the required
 * logo file input. This handler POSTs FormData (files included) to
 * /cart/add.js, then opens the cart drawer through the same
 * `added.ajaxProduct` contract — the shopper stays on the product page and
 * can keep adding colors/sizes of the same blank.
 *
 * Bound in the capture phase + stopPropagation, so it wins over the stock
 * bubble-phase submit handler when cart_type=drawer without editing it.
 *
 * Also in this file: color-pill image panning (bottom). The stock updater
 * reads variant.featured_media, which Shopify's variant JSON doesn't
 * include, so the gallery never follows color changes on its own. The
 * handler below pans explicitly using featured_image (present in JSON).
 */
(function () {
  // Both product form snippets include this file; never bind twice.
  if (window.__quoteAjaxInit) return;
  window.__quoteAjaxInit = true;

  function openDrawer(btn) {
    if (window.jQuery) {
      window.jQuery('body').trigger('added.ajaxProduct', [window.jQuery(btn)]);
    }
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: {} }));
  }

  function showError(form, message) {    form.querySelectorAll('.errors').forEach(function (el) { el.remove(); });
    var div = document.createElement('div');
    div.className = 'errors text-center';
    div.textContent = message;
    form.prepend(div);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('js-quote-ajax')) return;
    e.preventDefault();
    e.stopPropagation();

    var btn = form.querySelector('.add-to-cart');
    if (btn) btn.classList.add('btn--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (j) {
          throw new Error((j && j.description) || 'Add to cart failed.');
        });
      }
      return r.json();
    }).then(function () {
      form.querySelectorAll('.errors').forEach(function (el) { el.remove(); });
      if (btn) btn.classList.remove('btn--loading');
      openDrawer(btn);
    }).catch(function (err) {
      if (btn) btn.classList.remove('btn--loading');
      showError(form, (err && err.message) || 'Add to cart failed.');
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: { errorMessage: (err && err.message) || 'Add to cart failed.' }
      }));
    });
  }, true);

  /**
   * Normalize a Shopify image URL to its `<name>_<uuid>` core so different
   * size crops of the same photo compare equal:
   * `BC3001_black_…_<uuid>_900x.jpg?v=…` and `…_<uuid>_1800x1800.jpg` agree.
   */
  function photoKey(url) {
    if (!url) return '';
    var base = url.split('?')[0].split('/').pop() || '';
    return base.replace(/_(\d+x\d*|master|original)(\.[a-z]+)$/i, '$2').replace(/\.[a-z0-9]+$/i, '');
  }

  function formVariants(form) {
    var jsonEl = form.querySelector('textarea[id^="VariantsJson-"], script[data-bulk-variants]');
    if (!jsonEl) return null;
    try { return JSON.parse(jsonEl.value || jsonEl.textContent); }
    catch (err) { return null; }
  }

  function variantForColor(variants, color) {
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if ([v.option1, v.option2, v.option3].indexOf(color) === -1) continue;
      if (!match) match = v;
      if (v.available) { match = v; break; }
    }
    return match;
  }

  document.addEventListener('change', function (e) {
    // Skip changes that originated from gallery→pill sync below: the slider
    // is already where the user put it, and panning back to a stale target
    // is what desyncs the pills during rapid thumbnail clicks.
    if (window.__quoteSyncing) return;
    var input = e.target;
    if (!input || !input.matches) return;
    // Color detection by option handle (not data-color-name): the swatch
    // setting that adds data-color-name may be off while pills still render.
    var wrap = input.closest ? input.closest('.variant-input-wrap') : null;
    var isColorPill = !!wrap &&
      input.matches('input[type="radio"]') &&
      /colou?r/i.test(wrap.getAttribute('data-handle') || '');
    var bulkPills = null;
    if (!isColorPill) {
      if (!input.matches('.product-bulk-form__pills input[type="radio"]')) return;
      bulkPills = input.closest('.product-bulk-form__pills');
      var optName = bulkPills ? bulkPills.getAttribute('data-option-name') || '' : '';
      if (!/colou?r/i.test(optName)) return;
    }
    if (window.__quotePanDebug) console.log('[quote-pan] color change:', input.value);
    var form = input.closest('form');
    if (!form) { if (window.__quotePanDebug) console.log('[quote-pan] no form'); return; }
    var variants = formVariants(form);
    if (!variants) { if (window.__quotePanDebug) console.log('[quote-pan] no variants JSON'); return; }
    var color = input.value;
    var match = variantForColor(variants, color);
    // Preferred: the variant's assigned image (products imported with variant
    // media). Fallback for the rest of the catalog (SanMar imports have no
    // variant images): match the color name against the photo filenames —
    // "Black/ Atlantic" → "blackatlantic" in COTOM1687_blackatlantic_model_front.
    var wantKey = (match && match.featured_image && match.featured_image.src) ? photoKey(match.featured_image.src) : '';
    var colorSlug = String(color).toLowerCase().replace(/[^a-z0-9]+/g, '');
    if (!wantKey && !colorSlug) {
      if (window.__quotePanDebug) console.log('[quote-pan] no variant image and no usable color slug:', color);
      return;
    }
    if (window.__quotePanDebug) console.log('[quote-pan] color:', color, '| wantKey:', wantKey, '| slug:', colorSlug);
    var section = form.closest('.product-section') || document;
    // Match by photo file key, NOT by data-id: thumb data-id values are
    // media IDs while variant JSON carries image IDs (different spaces).
    // Both URLs share the same `<name>_<uuid>` core (size suffix differs).
    var thumb = null;
    var candidates = section.querySelectorAll('.product__thumb');
    for (var t = 0; t < candidates.length; t++) {
      var a = candidates[t];
      var href = a.getAttribute('href') || '';
      var img = a.querySelector('img');
      var ds = img ? (img.getAttribute('data-src') || img.getAttribute('src') || '') : '';
      var key = photoKey(href) || photoKey(ds);
      if (!key) continue;
      var hit = wantKey
        ? (key === wantKey || photoKey(ds) === wantKey)
        : (key.toLowerCase().replace(/[^a-z0-9]+/g, '').indexOf(colorSlug) !== -1);
      if (hit) {
        thumb = a;
        break;
      }
    }
    if (!thumb) { if (window.__quotePanDebug) console.log('[quote-pan] no thumb for', wantKey || colorSlug); return; }
    var thumbItem = thumb.closest('.product__thumb-item');
    var items = Array.prototype.slice.call(section.querySelectorAll('.product__thumb-item'));
    var index = items.indexOf(thumbItem || thumb);
    if (index < 0) return;
    var thumbsInit = false;
    if (window.jQuery) {
      // dontAnimate=true: flipping through a dozen intermediates at speed
      // is vertigo-inducing — jump straight to the color's photo.
      var main = section.querySelector('[id^="ProductPhotos-"]');
      if (main && window.jQuery(main).hasClass('slick-initialized')) {
        window.jQuery(main).slick('slickGoTo', index, true);
      }
      var thumbs = section.querySelector('[id^="ProductThumbs-"]');
      if (thumbs && window.jQuery(thumbs).hasClass('slick-initialized')) {
        thumbsInit = true;
        window.jQuery(thumbs).slick('slickGoTo', index, true);
      }
    }
    // No scrollIntoView when slick owns the strip: coordinates inside a
    // transformed track mislead it and the page jumps. slickGoTo already
    // brings the thumb into view.
    if (!thumbsInit) {
      (thumbItem || thumb).scrollIntoView({ block: 'nearest', inline: 'center' });
    }
  });

  /**
   * Reverse binding: scrolling/clicking the thumbnail carousel updates the
   * pills. On slick afterChange, map the current slide back to a color via
   * the variant JSON and check that color's pills (dispatching change so
   * price/variant-id/labels follow). Slides with no color match (lifestyle
   * shots) leave the pills alone.
   */
  function syncPillsToSlide(slider) {
    var section = slider.closest ? slider.closest('.product-section') : null;
    if (!section) return;
    var current = slider.querySelector('.slick-current img');
    if (!current) return;
    var key = photoKey(current.currentSrc || current.src);
    if (!key) return;
    var form = section.querySelector('form.product-single__form, form.product-bulk-form');
    if (!form) return;
    var variants = formVariants(form);
    if (!variants) return;
    // Candidate colors from every color pill group in this section.
    var colors = [];
    section.querySelectorAll('.variant-input-wrap').forEach(function (w) {
      if (!/colou?r/i.test(w.getAttribute('data-handle') || '')) return;
      w.querySelectorAll('input[type="radio"]').forEach(function (r) {
        if (colors.indexOf(r.value) === -1) colors.push(r.value);
      });
    });
    section.querySelectorAll('.product-bulk-form__pills').forEach(function (g) {
      if (!/colou?r/i.test(g.getAttribute('data-option-name') || '')) return;
      g.querySelectorAll('input[type="radio"]').forEach(function (r) {
        if (colors.indexOf(r.value) === -1) colors.push(r.value);
      });
    });
    var found = null;
    var keySlug = key.toLowerCase().replace(/[^a-z0-9]+/g, '');
    for (var i = 0; i < colors.length; i++) {
      var v = variantForColor(variants, colors[i]);
      if (v && v.featured_image && photoKey(v.featured_image.src) === key) {
        found = colors[i];
        break;
      }
    }
    // Fallback for variants without assigned images: match the photo
    // filename against the color name (see the pill→gallery handler above).
    if (!found) {
      for (var f = 0; f < colors.length; f++) {
        var slug = colors[f].toLowerCase().replace(/[^a-z0-9]+/g, '');
        if (slug && slug.length > 2 && keySlug.indexOf(slug) !== -1) {
          found = colors[f];
          break;
        }
      }
    }
    if (!found) return;
    if (window.__quotePanDebug) console.log('[quote-pan] gallery shows color:', found);
    // Suppress the pill→gallery pan while applying gallery state: the
    // slider is already correct and panning back would race rapid clicks.
    window.__quoteSyncing = true;
    try {
      section.querySelectorAll(
        '.variant-input-wrap input[type="radio"], .product-bulk-form__pills input[type="radio"]'
      ).forEach(function (r) {
        var groupIsColor = false;
        var w = r.closest('.variant-input-wrap');
        if (w && /colou?r/i.test(w.getAttribute('data-handle') || '')) groupIsColor = true;
        var g = r.closest('.product-bulk-form__pills');
        if (g && /colou?r/i.test(g.getAttribute('data-option-name') || '')) groupIsColor = true;
        if (!groupIsColor) return;
        if (r.value === found) {
          if (!r.checked) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else if (r.checked) {
          r.checked = false;
        }
      });
    } finally {
      window.__quoteSyncing = false;
    }
  }

  if (window.jQuery) {
    window.jQuery(document).on(
      'afterChange',
      '[id^="ProductPhotos-"]',
      function (e) { syncPillsToSlide(e.currentTarget); }
    );
  }
})();
